import React from 'react';

const Feed = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7959 20.9645L19.3589 16.1545C19.0749 15.7603 18.6633 15.4766 18.1938 15.3515L18.1399 15.4165C17.2449 16.4765 16.1068 17.6665 14.5568 19.1645C13.9883 19.7145 13.2278 20.0212 12.4368 20.0195C11.6462 20.0217 10.886 19.7153 10.3178 19.1655C8.73585 17.6355 7.57985 16.4225 6.67785 15.3485C6.20422 15.4715 5.78854 15.7562 5.50285 16.1535L2.06585 20.9645C1.95377 21.1215 1.88712 21.3064 1.87321 21.4988C1.85931 21.6913 1.89869 21.8838 1.98703 22.0553C2.07536 22.2268 2.20925 22.3707 2.37398 22.4711C2.53871 22.5715 2.72793 22.6246 2.92085 22.6245H21.9408C22.7948 22.6245 23.2908 21.6595 22.7948 20.9645"
        fill="#191F28"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4359 6.42646C12.7022 6.42037 12.9671 6.46756 13.2149 6.56524C13.4628 6.66293 13.6886 6.80914 13.8792 6.99531C14.0697 7.18147 14.2212 7.40383 14.3246 7.64934C14.4281 7.89484 14.4814 8.15853 14.4816 8.42494C14.4817 8.69135 14.4286 8.95509 14.3254 9.2007C14.2222 9.44631 14.071 9.66882 13.8806 9.85517C13.6902 10.0415 13.4645 10.188 13.2168 10.2859C12.969 10.3838 12.7042 10.4313 12.4379 10.4255C11.9074 10.4256 11.3987 10.215 11.0235 9.84003C10.6483 9.46505 10.4375 8.9564 10.4374 8.42596C10.4372 7.89553 10.6478 7.38677 11.0228 7.0116C11.3978 6.63644 11.9064 6.42559 12.4369 6.42546M11.7089 17.7275C11.9052 17.9152 12.1664 18.0199 12.4381 18.0197C12.7097 18.0195 12.9708 17.9145 13.1669 17.7265C17.7849 13.2645 19.2389 11.0265 19.2389 8.42646C19.2389 4.02246 15.0519 0.595462 10.4419 1.90846C7.53186 2.73846 5.63586 5.40046 5.63586 8.42646C5.63586 11.0285 7.09086 13.2655 11.7089 17.7265"
        fill="#191F28"
      />
    </svg>
  );
};

export default Feed;
